import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, ViewChild, ViewChildren } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet, Router } from '@angular/router';
import { ModalService } from '../../../services/modal.service';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { ItemsPerPageComponent } from '../../../components/itemsPerPage.component';
import { I18nTranslator } from '../../../i18n/translate';
import { ZSNResultType } from '../../../models/zsn-lists.model';
import { ZSNCampaign, ZSNOrderItem } from '../../../models/zsn.model';
import { BreakOnUnderscorePipe } from '../../../pipes/breakOnUnderscore.pipe';
import { CampaignYearPipe } from '../../../pipes/campaignYear.pipe';
import { CapitalizePipe } from '../../../pipes/capitalize.pipe';
import { ExtractAttributePipe } from '../../../pipes/extractAttribute.pipe';
import { HectareConverterPipe } from '../../../pipes/hectareConverter.pipe';
import { ExtractFarmNameFromOrderItemsPipe, ExtractParcelNameFromOrderItemsPipe } from '../../../pipes/results.pipe';
import { ToLabelPipe } from '../../../pipes/toLabel.pipe';
import { FarmService } from '../../../services/farm.service';
import { OrganisationService } from '../../../services/organisation.service';
import { ZSNListType, ZSNListsService } from '../../../services/zsn-lists.service';
import { ZSNService } from '../../../services/zsn.service';
import { Tooltip } from '../../../utils/Tooltip';
import { TooltipContent } from '../../../utils/TooltipContent';
import { sortingString } from '../../../utils/utils';
import { ARResultsComponent } from '../agrorendement/common/results.component';
import { ZSNUtils } from './zsn.utils';
import { TranslatePipe, TranslateDatePipe } from '../../../pipes/translate.pipe';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
  standalone: true,
  selector: 'zsn-results-cmp',
  templateUrl: '../agrorendement/common/results.component.html',
  styleUrls: ['../agrorendement/common/results.component.scss'],
  imports: [
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    CommonModule,
    FormsModule,
    Tooltip,
    TooltipContent,
    ItemsPerPageComponent,
    DatePipe,
    HectareConverterPipe,
    ToLabelPipe,
    CapitalizePipe,
    ExtractAttributePipe,
    CampaignYearPipe,
    BreakOnUnderscorePipe,
    ExtractParcelNameFromOrderItemsPipe,
    ExtractFarmNameFromOrderItemsPipe,
    TranslatePipe,
    TranslateDatePipe,
    PaginationModule,
    TooltipModule,
  ],
  providers: [ZSNService, FarmService, OrganisationService],
})
export class ZSNResultsComponent extends ARResultsComponent<ZSNOrderItem, ZSNCampaign, ZSNResultType> {
  @ViewChild('termPrefixFilter') public termPrefixFilter: ElementRef;
  @ViewChild('termFarmFilter') termFarmFilter: ElementRef;
  @ViewChild('termCampaignFilter') termCampaignFilter: ElementRef;
  @ViewChild('termResultTypeFilter') termResultTypeFilter: ElementRef;
  @ViewChild('termOrganisationFilter') termOrganisationFilter: ElementRef;
  @ViewChild('termValidationStatusFilter') termValidationStatusFilter: ElementRef;
  @ViewChild('termAvailabilityStatusFilter') termAvailabilityStatusFilter: ElementRef;
  @ViewChild('termMarkedForNotificationStatusFilter') termMarkedForNotificationStatusFilter: ElementRef;
  @ViewChild('termNotificationStatusFilter') termNotificationStatusFilter: ElementRef;
  @ViewChild('termNotificationAdvisorsStatusFilter') termNotificationAdvisorsStatusFilter: ElementRef;
  @ViewChild('allFilters', { static: true }) allFilters: ElementRef;

  @ViewChildren('resultCheckbox') resultCheckboxes: any;
  @ViewChild('checkboxAll') checkboxAll: any;

  constructor(
    protected service: ZSNService,
    protected listService: ZSNListsService,
    protected organisationService: OrganisationService,
    protected farmService: FarmService,
    protected i18nTranslator: I18nTranslator,
    protected router: Router,
    protected route: ActivatedRoute,
    protected modal: ModalService,
    protected ref: ChangeDetectorRef,
  ) {
    super();
    this.specyString = this.i18nTranslator.translate('ar.zsn.section');
    this.specyUrlPart = ['zsn'];
  }

  isCampaignCurrentlyOpen(campaign: ZSNCampaign): boolean {
    return ZSNUtils.isCampaignCurrentlyOpen(campaign);
  }

  getResultTypes(): Observable<Map<any, ZSNResultType[]>> {
    const listTypes = [ZSNListType.ZSN_RESULT_TYPES];
    const obs1 = this.listService.getListTypes(ZSNListType, ...listTypes).pipe(share());
    obs1.subscribe((lists) => {
      this.resultTypes = lists.get(ZSNListType.ZSN_RESULT_TYPES).sort(sortingString('label'));
      this.resultTypesDict = new Map<string, ZSNResultType>();
      for (const resultType of this.resultTypes) {
        this.resultTypesDict.set(resultType.code, resultType);
      }
    });
    return obs1;
  }
}
